module.exports = __webpack_public_path__ + "img/img_delivery_negative.b9ac6c6.png";